var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<h3 ng-if=\"serverError.status\">{{ serverError.status }} {{ serverError.statusText }}</h3>\n<p>{{ serverError.message }}</p>\n<p ng-if=\"serverError.data &amp;&amp; serverError.data.errorKey\">{{ t(serverError.data.errorKey) }}</p>\n<p>{{ serverError.data.errorMap }}</p>\n<div ng-if=\"serverError.data &amp;&amp; serverError.data.link\" class=\"linkWrapper\">\n  <p ng-bind-html=\"serverError.data.link\"></p>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/serverError.jade
 ** module id = 105
 ** module chunks = 1
 **/